module.exports = __webpack_public_path__ + "img/back.4c00c83a.png";